module.exports = __webpack_public_path__ + "img/logo_print.bd407766.png";